import styled from 'styled-components';

import useDischargeCalendarCounts from '../hooks/useDischargeCalendarCounts';
import useDischargeCalendarWeek from '../hooks/useDischargeCalendarWeek';
import useWeekNavigation from '../hooks/useWeekNavigation';
import CalendarLegend from '../shared/CalendarLegend';
import DateNavigation from '../shared/DateNavigation';

import WeekViewGrid from './WeekViewGrid';

export default function WeekView() {
  const { daysOfWeek, startDate, endDate } = useWeekNavigation();
  const { data: weekData, isFetching } = useDischargeCalendarWeek();
  const { data: counts } = useDischargeCalendarCounts({ startDate, endDate });

  return (
    <Container>
      <Header>
        <DateNavigation />
        <CalendarLegend />
      </Header>
      <CalendarContainer>
        <WeekViewGrid daysOfWeek={daysOfWeek} weekData={weekData} counts={counts} isLoading={isFetching} />
      </CalendarContainer>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 24px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

const CalendarContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  overflow: hidden;
`;
